<template>
  <div class="auth-content">
    <div class="guide">※新しいアカウントを作成するには、https://www.pronaid.co.jp/ からメールアドレスを登録してください。</div>
    <div class="left">
      <img src="@/assets/logo-symbol.svg" class="symbol" />
      <div class="welcome">Welcome</div>
      <div class="third-party-authes">
        <p>既にお持ちのアカウントでご利用頂けます</p>
        <img src="@/assets/facebook.svg" @click="signInWithFacebook" alt="facebook" />
        <img src="@/assets/google.svg" @click="signInWithGoogle" alt="google" />
        <img
          src="@/assets/twitter.svg"
          @click="signInWithTwitter"
          style="margin-left: 11px"
          alt="twitter"
        />
      </div>
    </div>
    <div class="right">
      <img src="@/assets/logo.svg" class="logo" />
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="メールアドレス">
          <el-input type="email" v-model="email"></el-input>
        </el-form-item>
        <el-form-item label="パスワード">
          <el-input type="password" v-model="password"></el-input>
        </el-form-item>
        <div class="message">{{message}}</div>
        <el-form-item style="margin: 0">
          <div style="text-align:right">
            <button
              @click.prevent="signIn"
              class="button login"
              :class="{'loading disabled': loading}"
            >{{ loading ? 'ログイン中' : 'ログイン'}}</button>
          </div>
        </el-form-item>
      </el-form>
      <div class="forgot" @click="goToResetPage">ログインでお困りの場合はこちら</div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import { mapGetters } from "vuex";
import store from "@/store";

export default {
  name: "Authentification",
  data() {
    return {
      createAccountError: "",
      createAccountVisible: false,
      createEmail: "",
      email: "",
      loading: false,
      password: "",
      pending: false,
      message: "",
      form: {
        name: "",
        password: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      user: "user"
    })
  },
  created() {
    document.title = "PronAid | サインイン";
  },
  methods: {
    goToResetPage() {
      this.$router.replace("/forgot");
    },
    signIn() {
      this.loading = true;
      let self = this;
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(user => {
          this.$router.replace("/dashboard");
        })
        .catch(err => {
          this.loading = false;
          console.log(err.code);
          switch (err.code) {
            case "auth/invalid-email":
              self.message = "メールアドレスの形式が間違っています";
              break;
            case "auth/wrong-password":
              self.message = "パスワードが間違っています";
              break;
            default:
              self.message = "エラーが発生しました";
          }
        });
    },
    signInWithGoogle() {
      let self = this;
      const provider = new firebase.auth.GoogleAuthProvider();
      provider.addScope("https://www.googleapis.com/auth/contacts.readonly");
      firebase.auth().languageCode = "ja";
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(function(result) {
          self.$router.replace("/dashboard");
        })
        .catch(function(error) {
          const errorCode = error.code;
          const errorMessage = error.message;
          const email = error.email;
          const credential = error.credential;
        });
    },
    signInWithFacebook() {
      let self = this;
      const provider = new firebase.auth.FacebookAuthProvider();
      firebase.auth().languageCode = "ja";
      provider.setCustomParameters({
        display: "popup"
      });
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(function(result) {
          console.log(result);
          const token = result.credential.accessToken;
          const user = result.user;
        })
        .catch(function(err) {
          console.log(err);
          switch (err.code) {
            case "auth/invalid-email":
              self.message = "メールアドレスの形式が間違っています";
              break;
            case "auth/wrong-password":
              self.message = "パスワードが間違っています";
              break;
            case "auth/account-exists-with-different-credential":
              self.message =
                "このメールアドレスですでにユーザー登録がされています";
              break;
            default:
              self.message = "エラーが発生しました";
          }
        });
    },
    signInWithTwitter() {
      let self = this;
      const provider = new firebase.auth.TwitterAuthProvider();
      firebase.auth().languageCode = "ja";
      provider.setCustomParameters({
        display: "popup"
      });
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(function(result) {
          self.$router.replace("/dashboard");
          console.log(result);
          const token = result.credential.accessToken;
          const user = result.user;
        })
        .catch(function(err) {
          console.log(err);
          switch (err.code) {
            case "auth/invalid-email":
              self.message = "メールアドレスの形式が間違っています";
              break;
            case "auth/wrong-password":
              self.message = "パスワードが間違っています";
              break;
            case "auth/account-exists-with-different-credential":
              self.message =
                "このメールアドレスですでにユーザー登録がされています";
              break;
            default:
              self.message = "エラーが発生しました";
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.auth-content {
  h1 {
    margin: 10px 0;
    font-size: 1.5rem;
  }
  box-shadow: 0 0 20px 4px rgba(0, 0, 0, 0.05);
  background-color: white;
  box-sizing: border-box;
  display: inline-block;
  height: 370px;
  width: 820px;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  &:hover {
    .left {
      .symbol {
        transform: scale(1.1);
        opacity: 1;
      }
    }
  }
}

.left {
  width: 40%;
  height: 100%;
  background-color: $main-color;
  float: left;
  position: relative;
  text-align: center;
  .symbol {
    width: 90px;
    margin-top: 70px;
    opacity: 0.8;
    transition: all 0.3s ease;
    /* opacity: 0.8; */
  }
  .welcome {
    color: white;
    font-weight: bold;
    font-size: 2rem;
    text-align: center;
    margin-top: 10px;
  }
}

.third-party-authes {
  position: absolute;
  width: 100%;
  text-align: center;
  bottom: 10px;
  p {
    margin: 0;
    font-size: 0.88rem;
    color: white;
  }
  img {
    cursor: pointer;
    width: 25px;
    margin: 8px;
    &:hover {
      transform: scale(1.1);
    }
  }
}

.right {
  box-sizing: border-box;
  padding: 40px 40px 50px 40px;
  width: 60%;
  height: 100%;
  display: inline-block;
}

.label {
  color: #888;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 5px;
}

.logo {
  width: 140px;
  display: block;
  margin: 0 auto 30px auto;
}
.login {
  margin: 20px 0;
  margin-left: auto;
  vertical-align: middle;
  padding: 5px 30px;
  font-size: 0.9rem;
  border-radius: 20px;
  transition: padding 0.5s ease, opacity 0.5s ease, width 0.5s ease;
  img {
    width: 20px;
    vertical-align: middle;
  }
}

.loading {
  background-image: url("../../assets/spinner.svg");
  background-repeat: no-repeat;
  background-position-y: center;
  background-position-x: 90%;
  background-size: 22px;
  padding: 5px 43px 5px 25px;
}
.message {
  color: $main-color;
  font-weight: bold;
  text-align: center;
  font-size: 0.83rem;
}
.guide {
  position: absolute;
  bottom: -30px;
  font-size: 0.82rem;
  color: #999;
}

.forgot {
  margin-top: 10px;
  color: #999;
  font-weight: bold;
  text-align: center;
  font-size: 0.8rem;
  cursor: pointer;
  &:hover {
    color: #777;
  }
}
</style>
